import { TagTypes } from '../constants/api.constants';
import request from '../utils/request';
import baseApi from './baseApi';

export function getAssistantActivity(restaurantUuid, data) {
  return request({
    url: `${process.env.REACT_APP_CFA_PROXY}/restaurants/${restaurantUuid}/assistant/activity`,
    method: 'get',
    data,
  });
}

const assistantApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getAssistantUsers: builder.query({
      query: restaurantUuid => ({
        url: `${process.env.REACT_APP_CFA_PROXY}/restaurants/${restaurantUuid}/assistant/users`,
        method: 'GET',
        data: {
          limit: 1000,
        },
      }),
      providesTags: [TagTypes.AssistantUsers],
      keepUnusedDataFor: 60,
    }),
    deleteAssistantActivity: builder.mutation({
      query: ({ restaurantUuid, id }) => ({
        url: `${process.env.REACT_APP_CFA_PROXY}/restaurants/${restaurantUuid}/assistant/activity`,
        method: 'DELETE',
        data: {
          id,
        },
      }),
    }),
    deleteAssistantHistory: builder.mutation({
      query: ({ restaurantUuid, sid }) => ({
        url: `${process.env.REACT_APP_CFA_PROXY}/restaurants/${restaurantUuid}/assistant/history`,
        method: 'DELETE',
        data: {
          sid,
        },
      }),
      invalidatesTags: (request, error) => (error ? [] : [TagTypes.AssistantUsers]),
    }),
  }),
});

export const {
  useGetAssistantUsersQuery: useGetAssistantUsers,
  useDeleteAssistantActivityMutation: useDeleteAssistantActivity,
  useDeleteAssistantHistoryMutation: useDeleteAssistantHistory,
} = assistantApi;

export default assistantApi;
